import apiClient from '@/plugins/axios';

export default {
	getQuestionLists(params) {
		let query = '?';
		Object.entries(params).forEach(([key, value]) => {
			if (key === 'currentPage') {
				key = 'pageNumber';
			}

			query += value || value === false ? `${key}=${value}&` : '';
		});

		return apiClient.get(`v1/QuestionList${query}`);
	},

	getQuestionList(questionListId) {
		return apiClient.get(`v1/QuestionList/${questionListId}`);
	},

	createQuestionList(questionList) {
		return apiClient.post('v1/QuestionList', questionList);
	},

	updateQuestionList(questionList) {
		var questionListId = questionList.id;

		return apiClient.put(`v1/QuestionList/${questionListId}`, questionList);
	},

	deleteQuestionList(questionListId) {
		return apiClient.delete(`v1/QuestionList/${questionListId}`);
	}
};
